import { render, staticRenderFns } from "./SkillRate.vue?vue&type=template&id=2dc315a6&scoped=true"
import script from "./SkillRate.vue?vue&type=script&lang=ts"
export * from "./SkillRate.vue?vue&type=script&lang=ts"
import style0 from "./SkillRate.vue?vue&type=style&index=0&id=2dc315a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc315a6",
  null
  
)

export default component.exports